<template>
    <div class='common common-form-inline'>
        <a-form-model
        ref="vertifyForm"
        :model="pageData"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        >
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="原管理员姓名" prop="realname">
                        <a-input v-model="pageData.realname" disabled/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="原管理员身份证" prop="certificateNum">
                        <a-input v-model="pageData.certificateNum" disabled/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="原管理员电话" prop="mobile">
                        <a-input v-model="pageData.mobile" disabled/>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="新管理员姓名" prop="newRealname">
                        <a-input v-model="pageData.newRealname"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="新原管理员身份证" prop="newCertificateNum">
                        <a-input v-model="pageData.newCertificateNum"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="新管理员电话" prop="newMobile">
                        <a-input v-model="pageData.newMobile"/>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="管理员身份证照片"  prop="file4510">
                        <div class="spaceLeft" style="width:600px">
                            <div>
                                <imgUpload
                                :file="file4"
                                :paramObj="paramObj4"
                                @uploadOk="uploadOk"
                                text="正面"
                                @remove="removeFile($event, 'file4')"
                                :removeaction="true"
                                name="file"></imgUpload>
                            </div>
                            <div>
                                <imgUpload
                                :file="file5"
                                :paramObj="paramObj5"
                                @uploadOk="uploadOk"
                                text="反面"
                                @remove="removeFile($event, 'file5')"
                                :removeaction="true"
                                name="file"></imgUpload>
                            </div>
                            <div>
                                <imgUpload
                                :file="file10"
                                :paramObj="paramObj10"
                                @uploadOk="uploadOk"
                                text="管理员手持身份证照片"
                                @remove="removeFile($event, 'file10')"
                                :removeaction="true"
                                name="file"></imgUpload>
                            </div>
                        </div>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-model-item label="授权委托书" prop="file7">
                      <div>
                            <imgUpload
                            :file="file7"
                            :paramObj="paramObj7"
                            @uploadOk="uploadOk"
                            @remove="removeFile($event, 'file7')"
                            :removeaction="true"
                            name="file"></imgUpload>

                        <a @click="downFile">授权委托书(管理员变更)模板下载</a>
                    </div>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </div>
</template>

<script>
import imgUpload from "@/components/ui/img-upload/img-upload"
import {getUserChangeApplyId,setModifyUserInfo} from "@/api/security.js"
import {fileSaveAPI,fileQueryAPI} from '@/api/file.js'
export default {
    name:"admin-modify",
    components: {imgUpload},
    data() {
        return {
            url:"/gb-bigtree-file/fileUpload",
            labelCol: { span: 9 },
            wrapperCol: { span: 12 },
            pageData:{},
            rules:{
                realname:{
                    required: true,
                    message: "请填写原管理员姓名",
                    trigger: "blur",
                    whitespace:true
                },
                certificateNum:{
                    required: true,
                    message: "请填写原管理员身份证",
                    trigger: "blur",
                    whitespace:true
                },
                mobile:{
                    required: true,
                    message: "请填写原管理员电话",
                    trigger: "blur",
                    whitespace:true
                },
                newRealname:{
                    required: true,
                    message: "请填写新管理员姓名",
                    trigger: "blur",
                    whitespace:true
                },
                newCertificateNum:{
                    required: true,
                    message: "请填写新管理员身份证",
                    trigger: "blur",
                    whitespace:true
                },
                newMobile:{
                    required: true,
                    message: "请填写新管理员电话",
                    trigger: "blur",
                    whitespace:true
                },
                file4510:{
                  required: true,
                  trigger: "blur",
                  validator: (rule, value, callback) => {
                    if (!this.file4.fileId || !this.file5.fileId || !this.file10.fileId) {
                      this.pageData.file4510 = undefined;
                      callback(new Error('请上传管理员身份证照片'));
                    }
                    else{
                      this.pageData.file4510 = "up_ok";
                      callback();
                    }
                  }
                },
                file7:{
                  required: true,
                  trigger: "change",
                  validator: (rule, value, callback) => {
                    if (!this.file7.fileId) {
                      this.pageData.file7 = undefined;
                      callback(new Error('请上授权委托书'));
                    }else {
                      this.pageData.file7 = "up_ok";
                      callback();
                    }
                  }
                }
            },
            file4:{},
            file5:{},
            file10:{},
            file7:{},
            paramObj4:{
                app:"portal-pc",
                module:"approve",
                user:"",
                tblBlId:"",
                superFiledId:"4",
                mdlId:"approve"
            },
            paramObj5:{
                app:"portal-pc",
                module:"approve",
                user:"",
                tblBlId:"",
                superFiledId:"5",
                mdlId:"approve"
            },
            paramObj10:{
                app:"portal-pc",
                module:"approve",
                user:"",
                tblBlId:"",
                superFiledId:"10",
                mdlId:"approve"
            },
            paramObj7:{
                app:"portal-pc",
                module:"approve",
                user:"",
                tblBlId:"",
                superFiledId:"7",
                mdlId:"approve"
            },
            // SECURITY_FILE_DOWNLOAD_URI2: '/static/templates/授权委托书_管理员变更.doc',
            SECURITY_FILE_DOWNLOAD_URI2: 'templat_06',
            aplyId:""
        };
    },
    computed: {

    },
    methods: {
        uploadOk(data,fileParams){
            const saveParams = {
                mdlId: 'approve',
                tblBlId: this.applyId,
                suprFileId:fileParams.superFiledId,
                fileTpCd: undefined,
                id: data[0]&&data[0].id,
                fileExpdNm:data[0]&&data[0].fileExpdNm,
                fileNm:data[0]&&data[0].name,
                fileRte:data[0]&&data[0].fileRte,
                fileSize:data[0]&&data[0].size
            };
            fileSaveAPI(saveParams).then(res => {
                this["file"+fileParams.superFiledId] = {...saveParams,fileId:res.data.fileId};
                this.$message.success("上传成功");
            }).catch(err => {
                console.log(err);
            })
        },
        removeFile(file, fileObj){
          this[fileObj] = {};
        },
        downFile(){
            this.utils.queryTemplateFile(this.SECURITY_FILE_DOWNLOAD_URI2)
        },
        getUserChangeApplyId(){
            getUserChangeApplyId().then(res => {
                this.applyId = res.data.aplyId;
            })
        },
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.vertifyForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            realname:this.pageData.realname,
                            certificateNum:this.pageData.certificateNum,
                            mobile:this.pageData.mobile,
                            newRealname:this.pageData.newRealname,
                            newCertificateNum:this.pageData.newCertificateNum,
                            newMobile:this.pageData.newMobile,
                            applyId: this.applyId
                        };
                        setModifyUserInfo(params,true).then(res => {
                            resolve(res);
                        }).catch(err => {
                            this.errMsg = err.description;
                            reject(err);
                        })
                    } else {
                        return false;
                    }
                });
            })
        }
    },
    created() {
        this.getUserChangeApplyId();
        let userObj = this.$store.getters["home/getUserObjSecurity"];
        this.pageData.realname = userObj.mnpltPsnNm;
        this.pageData.certificateNum = userObj.certificateNum;
        this.pageData.mobile = userObj.mobile;
    },
    mounted() {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/steps/admin-modify.vue